import axios from 'axios'
import { apiBaseUrl } from '../const'
import { forceLogout, getActiveToken, isTokenExpired, isLoginRequest } from './forceLogout'

export { getActiveToken, isLoginRequest } from './forceLogout'

const apiClient = axios.create({
  baseURL: import.meta.env.VITE_ADMIN_API_BASE_URL || apiBaseUrl,
  headers: {
    'Content-Type': 'application/json',
    Accept: '*/*',
  },
})

apiClient.interceptors.request.use(
  (config) => {
    const token = getActiveToken()
    const requestUrl = config.url ?? ''
    if (token) {
      if (!isLoginRequest(requestUrl) && isTokenExpired(token)) {
        forceLogout()
        return Promise.reject(new Error('Token expired'))
      }
      config.headers.Authorization = `Bearer ${token}`
    }
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type']
    }
    return config
  },
  (error) => Promise.reject(error),
)

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const requestUrl = error.config?.url ?? ''
    if (error.response?.status === 401 && !isLoginRequest(requestUrl)) {
      forceLogout()
    }
    return Promise.reject(error)
  },
)

export default apiClient
